import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingBottom: theme.spacing.space32,
    paddingTop: 70,
  },
  btnSkip: {
    position: "fixed",
    top: theme.spacing.space16,
    right: theme.spacing.space16,
    zIndex: theme.zIndex.dialog,
  },
  dots: {
    marginTop: theme.spacing.space16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.space8,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: theme.radius.button,
    transition: "width 0.5s",
    background: theme.colors.border1,
    "&.active": {
      width: 16,
      background: theme.colors.primary,
    },
  },
  btnNext: {
    padding: theme.spacing.space24,
    paddingBottom: 0,
  },
  btnPlay: {
    height: 44,
  },
}));
